import { Globals } from '../../modules/Globals';
import axios from 'axios';
import { ILocation } from '../../interfaces/ILocation';
import { ICategory } from '../../interfaces/ICategory';
import { IOption } from '../../interfaces/IOption';

const apiUrl = Globals.apiPath + '/locations';

export default class LocationsService {
  constructor() {}

  async getProvinces(country: string) {
    let res = await axios.get<ILocation[]>(`${apiUrl}/${country}/provinces`);
    return res.data;
  }

  async getCities(provinceId: number) {
    let res = await axios.get<ILocation[]>(`${apiUrl}/${provinceId}/cities`);
    return res.data;
  }

  async getById(id: number) {
    let res = await axios.get<ILocation>(`${apiUrl}/${id}`);
    return res.data;
  }
}
